import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Player } from '../models/Player';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(private http:HttpClient, private configService:ConfigurationService) { 
      this.baseUrl = this.configService.getApiEndpoint();
    }
  
    baseUrl:string;

    async searchPlayers():Promise<Array<Player>> {
      let endpoint = `${this.baseUrl}/players`;
          let result = await firstValueFrom(this.http.post<Player[]>(endpoint, {}));
          return result;
    }
}
